import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex full-width no-wrap justify-around q-mt-md",
  style: {"max-width":"400px"}
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "q-mt-md" }

import { useDialogPluginComponent } from 'quasar'
import { computed, PropType } from 'vue'
import { Advert } from 'src/models/advert'
import BaseDialogContent from 'src/apps/core/components/BaseDialogContent.vue'
import { CapacitorClipboard } from 'boot/inject-capacitor'


export default /*@__PURE__*/_defineComponent({
  __name: 'ShareModalLinkOrImage',
  props: {
  advert: {
    type: Object as PropType<Advert>,
    required: true
  }
},
  emits: [
  // REQUIRED; need to specify some events that your
  // component will emit through useDialogPluginComponent()
  ...useDialogPluginComponent.emits
],
  setup(__props) {





const canShareMobile = computed(() => {
  return CapacitorClipboard || (window && window.navigator && window.navigator.share)
})

const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent()
// dialogRef      - Vue ref to be applied to QDialog
// onDialogHide   - Function to be used as handler for @hide on QDialog
// onDialogOK     - Function to call to settle dialog with "ok" outcome
//                    example: onDialogOK() - no payload
//                    example: onDialogOK({ /*...*/ }) - with payload
// onDialogCancel - Function to call to settle dialog with "cancel" outcome

function clickLinkInput(event) {
  event.target.select()
  if (canShareMobile.value) {
    if (CapacitorClipboard) {
      CapacitorClipboard.write({
        string: event.target.value
      })
    } else {
      window.navigator.clipboard.writeText(event.target.value)
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(BaseDialogContent, { "header-label": "Inserat teilen" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_q_btn, {
                class: "q-pa-lg",
                style: {"aspect-ratio":"1"},
                color: "grey-3",
                "text-color": "dark",
                unelevated: "",
                rounded: "",
                stack: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onDialogOK)('image')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_icon, {
                      name: "fas fa-image",
                      size: "lg"
                    })
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("div", null, "In Story", -1))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_q_btn, {
                class: "q-pa-lg",
                style: {"aspect-ratio":"1"},
                color: "grey-3",
                "text-color": "dark",
                unelevated: "",
                rounded: "",
                stack: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onDialogOK)('link')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_icon, {
                      name: "fas fa-link",
                      size: "lg"
                    })
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("div", null, "Als Link", -1))
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_input, {
              style: {"max-width":"400px"},
              "model-value": __props.advert.seo_link,
              class: "full-width",
              dense: "",
              outlined: "",
              readonly: "",
              onClick: _withModifiers(clickLinkInput, ["stop"])
            }, null, 8, ["model-value"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})